import React, { useState } from "react";
import {
  Grid,
  CircularProgress,
  Typography,
  TextField,
  Fade,
} from "@material-ui/core";
import { withRouter } from "react-router-dom";
import config from "../../config";

// styles
import useStyles from "./styles";

// logo
import logo from "./kochul_logo.png";

// context
import { useUserDispatch, loginUser } from "../../context/UserContext";

function Login(props) {
  var classes = useStyles();

  // global
  var userDispatch = useUserDispatch();

  // local
  var [isLoading, setIsLoading] = useState(false);
  var [error, setError] = useState(null);
  var [loginValue, setLoginValue] = useState("");
  var [passwordValue, setPasswordValue] = useState("");
  const [baseUrl, setBaseUrl] = useState(config.config[0].baseUrl);

  const onSubmit = async e => {
    setIsLoading(true);

    if (loginValue != "" && passwordValue != "") {
      const newLogin = {
        email: loginValue, password: passwordValue
      };
      
      const response = await fetch(baseUrl + "login", {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify(newLogin)
      });

      const json = await response.json();
      if (json.status.message == "Ok") {
        localStorage.setItem('token', json.content.token);
        localStorage.setItem('name', json.content.name + " " + json.content.lastName);
        localStorage.setItem('idUserSystem', json.content.id);
        loginUser(
          userDispatch,
          json.content.userType,
          props.history,
          setIsLoading,
          setError,
        )
      }

      setLoginValue("");
      setPasswordValue("");
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  }

  return (
    <Grid container className={classes.container}>
      <div className={classes.logotypeContainer}>
        <img src={logo} alt="logo" className={classes.logotypeImage} />
      </div>
      <div className={classes.formContainer}>
        <div className={classes.form}>
          <React.Fragment>
            <Fade in={error}>
              <Typography color="secondary" className={classes.errorMessage}>
                Credenciales incorrectas
              </Typography>
            </Fade>
            
            <TextField
              id="email"
              InputProps={{
                classes: {
                  underline: classes.textFieldUnderline,
                  input: classes.textField,
                },
              }}
              value={loginValue}
              onChange={e => setLoginValue(e.target.value)}
              margin="normal"
              placeholder="Correo"
              type="email"
              fullWidth
            />
            <TextField
              id="password"
              InputProps={{
                classes: {
                  underline: classes.textFieldUnderline,
                  input: classes.textField,
                },
              }}
              value={passwordValue}
              onChange={e => setPasswordValue(e.target.value)}
              margin="normal"
              placeholder="Contraseña"
              type="password"
              fullWidth
              onKeyPress={event => {
                if (event.key === 'Enter') {
                  onSubmit();
                }
              }}
            />
            <div className={classes.formButtons}>
              {isLoading ? (
                <CircularProgress size={26} className={classes.loginLoader} />
              ) : (
                <>
                  <button
                    className={loginValue.length === 0 || passwordValue.length === 0 ?
                      classes.disableButton : classes.enableButton}
                    disabled={(loginValue.length === 0 || passwordValue.length === 0)}
                    onClick={onSubmit}
                  >Inicio</button>
                </>
              )}
            </div>
          </React.Fragment>
        </div>
        <Typography color="primary" className={classes.copyright}>

        </Typography>
      </div>
    </Grid>
  );
}

export default withRouter(Login);
